var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.80469 15.4771C2.80469 15.4771 2.94669 17.2151 2.97969 17.7631C3.02369 18.4981 3.30769 19.3191 3.78169 19.8891C4.45069 20.6971 5.23869 20.9821 6.29069 20.9841C7.52769 20.9861 16.5227 20.9861 17.7597 20.9841C18.8117 20.9821 19.5997 20.6971 20.2687 19.8891C20.7427 19.3191 21.0267 18.4981 21.0717 17.7631C21.1037 17.2151 21.2457 15.4771 21.2457 15.4771",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49609 5.32949V4.95849C8.49609 3.73849 9.48409 2.75049 10.7041 2.75049H13.2861C14.5051 2.75049 15.4941 3.73849 15.4941 4.95849L15.4951 5.32949",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9961 16.6783V15.3843",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 8.38905V11.8561C4.668 13.1211 6.966 14.0071 9.488 14.3581C9.79 13.2571 10.783 12.4501 11.99 12.4501C13.178 12.4501 14.191 13.2571 14.473 14.3681C17.005 14.0171 19.312 13.1311 21.24 11.8561V8.38905C21.24 6.69505 19.877 5.33105 18.183 5.33105H5.817C4.123 5.33105 2.75 6.69505 2.75 8.38905Z",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.51a4dbc5bc00ac77fe0ac40cbcc246c0.svg";
export { ForwardRef as ReactComponent };